<aig-modal class="aig-modal-edit" position="center" customMaxWidth="500px">
  <div class="u-p-8 u-pb-3" body>
    <div class="p-flexcc u-dir-col">
      <img src="./assets/images/logos/logo.svg" class="u-mb-3" />
      <p class="u-fs-18 u-fw-400 u-color-black u-mt-def">
        Datos guardados con éxito
      </p>
    </div>
  </div>
  <div class="u-p-8 u-pt-def" buttons>
    <button
      class="aig-modal-edit__btn e-btn--primary p-flexcc"
      (click)="clickHide()"
    >
      <p class="u-fs-16 u-fw-600">Aceptar</p>
    </button>
  </div>
</aig-modal>
